import { useCallback, useMemo } from 'react';

import { useAtom } from 'jotai';
import { selectAtom } from 'jotai/utils';

import { formFormMapAtom } from '../../atoms';
import { useFormyContext } from '../useFormyContext';

const useSelectionValidationForm = <T, K extends keyof T>(select?: K) => {
  const { store } = useFormyContext();
  const [data] = useAtom(
    selectAtom(
      formFormMapAtom,
      // @ts-expect-error -- TODO: fix this
      useCallback(
        (data: T) => {
          if (select) return data[select];
          return data;
        },
        [select]
      )
    ),
    { store }
  );

  return useMemo(() => data, [data]);
};

export { useSelectionValidationForm };
